// components/CustomDropdown.js

import { useState, useRef, useEffect, useContext } from 'react';
import { ChartContext } from "@contexts/ChartContext";
import "@styles/utils.css";
import styles from '@components/UI/Modal/ModalUI.module.css';
import api from '@utils/api';
import { toast } from 'react-toastify';

import ModalUI from "@components/UI/Modal/ModalUI";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faPlus } from '@fortawesome/fontawesome-free-solid'

const WatcherDropdown = () => {

    const {
        setWatchersTitle,
        watchersTitle,
        activeWatcherIndex,
        setActiveWatcherIndex,
        watchersUpdated,
        setWatchersUpdated,
        allMarketWatcher,
        setAllMarketWatcher,
        translatedTexts
    } = useContext(ChartContext);

    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (allMarketWatcher.length) {
            let hasWatcher = allMarketWatcher.find(i => i.id == activeWatcherIndex)
            if (!hasWatcher) {
                setActiveWatcherIndex(allMarketWatcher[0].id)

            }
        }

    }, [allMarketWatcher])

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (index) => {
        if (index === "new_wacther") {

            setIsModalOpen(true)
        } else {
            setActiveWatcherIndex(index + "");
        }
        setIsOpen(false);
    };
    const handleInputChange = (e) => {
        setInputValue(e.target.value)
    }

    const handleButtonClick = async () => {
        try {
            const response = await api.post(`/panel/market-watch/create`, { name: inputValue }).then(res => res.data);

            if (response.status) {
                toast.success(response.message)
                setIsModalOpen(false)
                setWatchersUpdated(true)
                setActiveWatcherIndex(response.id)

            } else {
                toast.error(response.message)
            }

        } catch (error) {


        }

    }
    return (
        <div>


            <div className="z-10 rounded-lg p-2 bg-tt-200  text-tt-content" ref={dropdownRef}>
                <div className="flex items-center justify-between cursor-pointer" onClick={toggleDropdown}>
                    <div className='ml-2'>
                        <i className="fa-duotone fa-list-ul ml-2"></i>
                        <span

                        >{allMarketWatcher?.find(item => item.id == activeWatcherIndex)?.name}</span>
                    </div>
                    <FontAwesomeIcon icon={faChevronDown} />

                </div>
                {isOpen && (
                    <div className="absolute mt-5  rounded-md bg-tt-100 shadow-lg z-50 ">
                        <div className="py-1 max-h-60 overflow-auto text-tt-content">
                            {allMarketWatcher.map((item) => (
                                <div
                                    key={item.id}
                                    onClick={() => handleSelect(item.id)}
                                    className="w-full text-left px-4 py-2 text-sm  hover:bg-indigo-600 hover:text-white flex items-center justify-between cursor-pointer"
                                >
                                    {item.name}

                                </div>
                            ))}
                            <div
                                key="new-watcher"
                                onClick={() => handleSelect("new_wacther")}
                                className="w-full text-left px-4 py-2 text-sm hover:bg-indigo-600 hover:text-white flex items-center justify-between cursor-pointer"
                            >

                                <div className='ml-2'>
                                    {translatedTexts?.watchlist?.watcher_add_new}

                                </div>
                                <FontAwesomeIcon icon={faPlus} />


                            </div>
                        </div>
                    </div>
                )}
            </div>
            <ModalUI isOpen={isModalOpen} onClose={closeModal} customClass={translatedTexts?.class?.direction}>
                <p>{translatedTexts?.modal?.watchlist_add?.content}</p>
                <div className="flex mt-2">


                    <input
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleButtonClick();
                            }
                        }}
                        placeholder={translatedTexts?.modal?.watchlist_add?.add_watchlist_input_placehodler}
                        className="flex-1 px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 text-white dark:text-black  placeholder-gray-400 dark:placeholder-gray-100 focus:outline-none focus:ring-2 focus:ring-red-500 dark:focus:ring-red-400 transition-all"
                    />

                </div>
                <div
                    onClick={handleButtonClick}
                    className=" px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-300 transition mt-2 w-fit cursor-pointer"
                >
                    {translatedTexts?.modal?.watchlist_add?.add_watchlist_btn_text}
                </div>
            </ModalUI>
        </div>

    );
};

export default WatcherDropdown;
